function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.7116 8.31905C19.9863 8.04432 20.4317 8.04432 20.7064 8.31905L23.794 11.4066C24.0687 11.6813 24.0687 12.1267 23.794 12.4014L20.7064 15.4889C20.4317 15.7637 19.9863 15.7637 19.7116 15.4889C19.4368 15.2142 19.4368 14.7688 19.7116 14.4941L21.5982 12.6075H10.1844C9.79584 12.6075 9.48088 12.2925 9.48088 11.904C9.48088 11.5155 9.79584 11.2005 10.1844 11.2005H21.5982L19.7116 9.31392C19.4368 9.03919 19.4368 8.59377 19.7116 8.31905Z",
  fill: "#738BA5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.02068 2.05486C2.62117 1.45142 3.47108 1 4.41971 1H13.9363C15.6986 1 17.2583 2.45436 17.2583 4.32201V6.66695C17.2583 7.05547 16.9433 7.37043 16.5548 7.37043C16.1663 7.37043 15.8513 7.05547 15.8513 6.66695V4.32201C15.8513 3.25847 14.9489 2.40697 13.9363 2.40697H4.41971C3.92229 2.40697 3.41409 2.64925 3.01798 3.0473C2.6164 3.45086 2.40697 3.93618 2.40697 4.32201V18.9779C2.40697 19.7184 2.61931 20.3155 2.93972 20.7125C3.25073 21.0978 3.68249 21.3229 4.2243 21.3229H14.1121C14.576 21.3229 15.0093 21.1042 15.3392 20.7503C15.6755 20.3896 15.8513 19.9444 15.8513 19.5837V17.102C15.8513 16.7134 16.1663 16.3985 16.5548 16.3985C16.9433 16.3985 17.2583 16.7134 17.2583 17.102V19.5837C17.2583 20.3564 16.9064 21.1325 16.3683 21.7097C15.8237 22.2939 15.0357 22.7298 14.1121 22.7298H4.2243C3.2419 22.7298 2.41324 22.3003 1.8449 21.5962C1.28596 20.9037 1 19.9766 1 18.9779V4.32201C1 3.47673 1.42566 2.6528 2.02068 2.05486Z",
  fill: "#738BA5"
});

function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.d63064fa.svg";
export { ForwardRef as ReactComponent };